var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg824",
    width: 33.279999,
    height: 30.08,
    viewBox: "0 0 33.279999 30.08",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs828"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer8",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19.240916,21.92976 31.44889,1.8110855 H 1.8109343 L 6.0443992,8.328924 m 3.2512693,5.054152 2.3270385,3.800578",
    stroke: "#cc214f",
    strokeWidth: 4.11788,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path948-5-5",
    style: {
      display: "inline",
      fill: "none",
      stroke: "#00b0f0",
      strokeWidth: 3.62217,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.520713,25.515395 c 0,-2.502818 2.031752,-4.531855 4.537921,-4.531855 2.506169,0 4.537924,2.029037 4.537924,4.531855 0,2.502818 -2.031755,4.531851 -4.537924,4.531851 -2.506169,0 -4.537921,-2.029033 -4.537921,-4.531851 z m 5.871796,0 c 0,-0.735671 -0.597219,-1.332091 -1.333875,-1.332091 -0.736655,0 -1.333873,0.59642 -1.333873,1.332091 0,0.73567 0.597218,1.332088 1.333873,1.332088 0.736656,0 1.333875,-0.596418 1.333875,-1.332088 z",
    fill: "#0f2426",
    id: "path950-4-1",
    style: {
      display: "inline",
      fill: "#00b0f0",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.13742,
      strokeOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.e75eb4f865803ba2835669f7e9c378fe.svg";
export { ForwardRef as ReactComponent };